import { createSlice } from '@reduxjs/toolkit';

const initialConfirmationState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: null,
	confirmationForEdit: undefined,
	confirmationData: undefined,
	lastError: null,
};

export const callTypes = {
	list: 'list',
	action: 'action',
};

export const confirmationSlice = createSlice({
	name: 'confirmation',
	initialState: initialConfirmationState,
	reducers: {
		catchError: (state, action) => {
			state.error = action.payload.error;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false;
			} else {
				state.actionsLoading = false;
			}
		},

		startCall: (state, action) => {
			state.error = null;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true;
			} else {
				state.actionsLoading = true;
			}
		},

		// getConfirmationById
		confirmationFetched: (state, action) => {
			state.actionsLoading = false;
			state.error = null;
			state.confirmationData = action.payload.confirmationData;
		},

		// findConfirmations
		confirmationsFetched: (state, action) => {
			const { total_items, items } = action.payload;
			state.listLoading = false;
			state.error = null;
			state.entities = items;
			state.totalCount = total_items;
		},

		// Set to default state actionLoading & error
		confirmationReload: (state, action) => {
			state.actionsLoading = false;
			state.listLoading = false;
			state.error = null;
		},

	},
});

